/*
 * auth (context)
 */
import type { Session, User } from "@supabase/supabase-js"
import type { UserRole } from "@emr/types"
import { createContext } from "react"

type AuthState = {
	session: Session | null
	user: User | null
	role: UserRole
	signOut: () => Promise<void>
	isLoading: boolean
}

const initialState: AuthState = {
	session: null,
	user: null,
	role: "guest",
	signOut: async () => undefined,
	isLoading: true,
}

export const AuthContext = createContext<AuthState>(initialState)
